// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore
//import { MainStore } from '../stores/MainStore';

// Components
import Checkbox from '@material-ui/core/Checkbox';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

/**
 * @description Props Interface
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Props
 */
interface Props {
    columns: Array<any>;
    readonly?: boolean;
    numSelected: number;
    onRequestSort: any;
    onSelectAllClick: any;
    order: any;
    orderBy: string;
    rowCount: number;
}

/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @description Component EnhancedTableHead
 */
export default connect<{}, {}, Props>((state) => state)(class EnhancedTableHead extends React.Component<Props, {}> {

    /**
     * Creates an instance of EnhancedTableHead.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     */
    constructor(props: any) {
        super(props);
    }

    createSortHandler = (property: any) => (event: any) => {
        this.props.onRequestSort(event, property);
    }

    /**
     * @description Render the AppBar Component
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    render() {
        const { columns, onSelectAllClick, order, orderBy, numSelected, rowCount, readonly } = this.props;

        return (
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                        {!readonly && <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />}
                    </TableCell>
                    {columns.map((column: any) => {
                        if (column.id != "id") {
                            return (
                                <TableCell
                                    key={column.id}
                                    numeric={column.numeric}
                                    padding={column.disablePadding ? 'none' : 'default'}
                                    sortDirection={orderBy === column.id ? order : undefined}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </TableCell>
                            );
                        } else {
                            return null;
                        }
                    }, this)}
                    {!this.props.readonly &&
                        <TableCell numeric={true}>
                            <TableSortLabel>Actions</TableSortLabel>
                        </TableCell>
                    }
                </TableRow>
            </TableHead>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/components/DataTable/EnhancedTableHead.tsx